module.exports = __webpack_public_path__ + "static/media/Lesson-8-20-The-Struggle-for-the-Faith.0f26e049.pdf";